import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { images } from '../../../../utils/customFn'
import './plans.scss'
const Plans = ({ data, heading }) => {
    return (
        <div className='plans'>
            <div className='heading-top-main'>
                <h2>{heading}</h2>
            </div>
            <Row>
                <Col md={7} sm={12}>
                    <div className='content leftside'>
                        <div className='heading'>
                            <h2>{data.blue_heading}</h2>
                        </div>
                        <div className='para'>
                            <p>{data.blue_para}</p>
                        </div>
                    </div>
                </Col>
                <Col md={5} sm={12}>
                    <div className='content rightside'>
                        <div className='cup_img'>
                            <img src={data.purple_icon} />
                        </div>
                        <div className='heading purple'>
                            <h2>{data.purple_heading}</h2>
                        </div>
                        <div className='para'>
                            <p>{data.purple_para}</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Plans
